import { replaceDoubleSlashWithSingleSlash } from "@enfusion-ui/utils";
import { PORTFOLIO_LATEST_CONFIG_VERSION } from "../constants";
import DOCUMENTS_API from "./documents";
const PORTFOLIO = "portfolio";
export default (restServer) => {
    const documentsAPI = DOCUMENTS_API(restServer);
    return {
        GET_ROOT_NODE: documentsAPI.GET_ROOT_NODE.bind(this, PORTFOLIO),
        GET_SEARCH_ROOT_NODE: documentsAPI.GET_SEARCH_ROOT_NODE.bind(this, PORTFOLIO),
        GET_ROOT_NODE_FACTORY: () => documentsAPI.GET_ROOT_NODE_FACTORY(PORTFOLIO),
        CREATE_FOLDER: (root, filePath) => documentsAPI.CREATE_FOLDER(PORTFOLIO, `${root}/${filePath}`),
        RENAME_FOLDER: (filePath, newFolderName) => documentsAPI.RENAME_FOLDER(PORTFOLIO, filePath, newFolderName),
        DELETE_ENTRY: (filePath) => documentsAPI.DELETE_ENTRY(PORTFOLIO, filePath),
        MOVE_ENTRY: (filePath, destinationFolder) => documentsAPI.MOVE_ENTRY(PORTFOLIO, filePath, destinationFolder),
        DOWNLOAD_PORTFOLIO: (filePath) => documentsAPI.DOWNLOAD(PORTFOLIO, filePath),
        STORE_PORTFOLIO: ({ path, rootPath, name, version, config, settings, configVersion = PORTFOLIO_LATEST_CONFIG_VERSION, forceWrite = false, }) => documentsAPI.UPLOAD(PORTFOLIO, rootPath, {
            path: replaceDoubleSlashWithSingleSlash(`/${path}/`),
            forceWrite,
            content: {
                name,
                version,
                config,
                settings,
                configVersion,
            },
        }),
    };
};
